var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.24 0H1.76C.788 0 0 .785 0 1.753V18.89c0 .968.788 1.753 1.76 1.753h29.48c.972 0 1.76-.785 1.76-1.753V1.753C33 .785 32.212 0 31.24 0z",
    fill: "#0E4595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.241 14.649l1.468-8.58h2.348l-1.47 8.58h-2.346zM23.07 6.254a6.084 6.084 0 00-2.105-.36c-2.32 0-3.953 1.163-3.967 2.83-.014 1.234 1.166 1.921 2.057 2.332.914.42 1.22.689 1.216 1.064-.005.575-.73.838-1.404.838-.94 0-1.439-.13-2.21-.45l-.303-.137-.33 1.921c.55.24 1.563.447 2.616.458 2.468 0 4.07-1.15 4.088-2.932.01-.976-.616-1.718-1.97-2.33-.821-.398-1.324-.662-1.319-1.064 0-.357.426-.738 1.345-.738a4.345 4.345 0 011.757.328l.21.1.319-1.86zm6.041-.185h-1.814c-.562 0-.982.153-1.23.711l-3.486 7.863h2.465s.403-1.057.495-1.29l3.006.005c.07.3.286 1.285.286 1.285h2.179l-1.9-8.574zm-2.878 5.54c.194-.494.935-2.399.935-2.399-.014.023.193-.496.312-.818l.158.74.544 2.477h-1.95zm-15.985-5.54l-2.299 5.85-.245-1.189c-.427-1.37-1.76-2.855-3.251-3.599l2.102 7.504 2.484-.003 3.696-8.563h-2.487z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.805 6.069H2.019l-.03.178c2.945.71 4.894 2.427 5.703 4.489L6.87 6.793c-.142-.543-.554-.705-1.064-.724z",
    fill: "#F2AE14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e59a69a229a54ead995bf857e7430484.svg";
export { ForwardRef as ReactComponent };